import React, { Component } from 'react'
import { GridColumn, DataGrid, LinkButton, Panel } from 'rc-easyui';
import { Button } from 'reactstrap';
import { API_URL } from "../../../constants";
import { getFormattedDate } from "../../../helpers";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
const axios = require("axios");

export default class ViewVersion extends Component {
  constructor(props) {
    super(props)

    this.state = {
      Version: [],
      pageOptions: {},
      form: {
        total: '',
        pageSize: '',
        pageNumber: ''

      },
      selected: {},
      isLoading: false,
    }
  }

  componentDidMount = () => {
    this.setState({
      pageOptions: {
        loading: true,
        pageOptions: {
          pageNumber: 0,
          pageSize: 10,
          layout: [
            "list",
            "sep",
            "first",
            "prev",
            "next",
            "last",
            "sep",
            "refresh",
            "sep",
            "manual",
            "info",
          ],
        }
      }
    }, () => {
      this.refereshData();
    })
  }

  refereshData = async () => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
      headers: {
        authorization: erp_token_type + ' ' + erp_access_token,
        'Content-Type': 'application/json',
      },
    }
    //   console.log(erp_access_token)
    if (erp_access_token != null) {
      this.setState({
        isLoading: true,
      })
      let url = API_URL + `api/fetchallversion`;
      axios.get(url, headerConfig)
        .then((response) => {

          if (response.status === 200) {
            let tempObj = response.data.object
            tempObj = tempObj.map(data => {
              let time = getFormattedDate(data.versionStartDate);
              let time1 = getFormattedDate(data.versionEndDate);
              data['versionStartDate'] = time
              data['versionEndDate'] = time1
              return data
            })
            this.setState({
              Version: tempObj,
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            })
          } else {
            return [],
              this.setState({
                pageOptions: {
                  pageOptions: { ...this.state.pageOptions.pageOptions },
                  loading: false,
                },
              });
          }
        })
        .catch((error) => {
          return [],
            this.setState({
              pageOptions: {
                pageOptions: {
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
        })
    } else {
      const resp = await getAccessToken()
      if (resp) {
        this.refereshData()
      }
    }
  }

  convertTimeStampToTime = (timeStamp) => {
    const date = new Date(timeStamp);
    let year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate();
    return `${year}-${month}-${day}`
  }

  onSelectionChange = (selectedRow) => {
    this.setState({
      selected: selectedRow,
    });
  }

  onPageChange = (event) => {
    //delete event["refresh"];
    delete event["filterRules"];
    //console.log(event);
    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.refereshData();
      }
    );
  }

  render() {
    const { Version } = this.state;
    return (
      <div>
        <Panel
          title='Version Lists'
          bodyStyle={{ padding: 0 }}
          style={{ height: 480 }}
        >
          <DataGrid
            data={Version}
            style={{ height: 450 }}
            selectionMode='single'
            {...this.state.pageOptions}
            pagination
            {...this.props.selectedRow}
            onPageChange={this.onPageChange}
            onSelectionChange={(selection) =>
              this.props.onSelectionChange(selection)
            }
          >
            <GridColumn
              field='rn'
              align='center'
              width='30px'
              cellCss='datagrid-td-rownumber'
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            />
            <GridColumn field="version" title="Version" ></GridColumn>
            <GridColumn field="versionStartDate" title="Version Start Date"
            // render={({ row }) => (
            //   <span>{getFormattedDate(row.versionStartDate)}</span>
            // )}
            ></GridColumn>
            <GridColumn field="versionEndDate" title="Version End Date"
            // render={({ row }) => (
            //   <span>{getFormattedDate(row.versionEndDate)}</span>
            // )}
            ></GridColumn>
            <GridColumn field="act" title="Actions" align="center" width={110}
              render={({ row }) => (
                <div>
                  <LinkButton
                    onClick={() => this.props.OnEditClick(row)}
                    style={{ width: 50 }}
                  >Edit</LinkButton>
                </div>
              )}
            />
          </DataGrid>
        </Panel>
      </div >
    )
  }
}
